export default class User {
    constructor(data) {
        this.data = {};
        this.data = data;
    }
    get id() {
        return this.data.id;
    }
    get name() {
        return this.data.name;
    }
    get locationWiseTimezone() {
        return this.data.locationWiseTimezone;
    }
    set locationWiseTimezone(value) {
        this.data.locationWiseTimezone = value;
    }
    get locationWiseOpenHours() {
        return this.data.locationWiseOpenHours;
    }
    set locationWiseOpenHours(value) {
        this.data.locationWiseOpenHours = value;
    }
    get locationWiseZoomAdded() {
        return this.data.locationWiseZoomAdded;
    }
    set locationWiseZoomAdded(value) {
        this.data.locationWiseZoomAdded = value;
    }
    get locationWiseMeetingLocation() {
        return this.data.locationWiseMeetingLocation;
    }
    set locationWiseMeetingLocation(value) {
        this.data.locationWiseMeetingLocation = value;
    }
    get userCalendar() {
        if (this.data.userCalendar === undefined) {
            this.data.userCalendar = {};
        }
        return this.data.userCalendar;
    }
    set userCalendar(values) {
        this.data.userCalendar = values;
    }
    get permissions() {
        return this.data.permissions;
    }
    set permissions(value) {
        this.data.permissions = value;
    }
    get profilePicture() {
        return this.data.profilePhoto;
    }
}
